import { useEffect } from 'react'
import { useCredits } from '../hooks/useCredits'
import { ANALYTICS_CONSENT_UPDATED_EVENT, isAnalyticsConsentGranted } from '../lib/consent'
import { setUserProperties } from '../lib/posthog'

export function UserPropertyEnricher() {
  const { data: credits } = useCredits()

  useEffect(() => {
    const syncProperties = () => {
      if (!credits || !isAnalyticsConsentGranted()) return

      setUserProperties({
        plan: credits.subscription_tier ?? 'free',
        total_credits: credits.total_balance ?? 0,
      })
    }

    syncProperties()
    window.addEventListener(ANALYTICS_CONSENT_UPDATED_EVENT, syncProperties)

    return () => {
      window.removeEventListener(ANALYTICS_CONSENT_UPDATED_EVENT, syncProperties)
    }
  }, [credits?.subscription_tier, credits?.total_balance])

  return null
}
